import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export const useClientStore = create(
  persist(
    (set) => ({
      selectedClientId: null,
      selectedClientCode: null,
      selectedClientName: null,
      setClient: ({ id, code, name }) =>
        set({ selectedClientId: id, selectedClientCode: code, selectedClientName: name }),
      clearClient: () =>
        set({ selectedClientId: null, selectedClientCode: null, selectedClientName: null }),
    }),
    {
      name: 'mp-admin-client',
      partialize: (s) => ({
        selectedClientId: s.selectedClientId,
        selectedClientCode: s.selectedClientCode,
        selectedClientName: s.selectedClientName,
      }),
    }
  )
);
